import React from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { useMutationAddNewAccount } from 'Customers/hooks/useCustomers';
import { buildSubscriptionPayload } from 'Customers/subscriptionPayload';
import useResolveHandler from 'Shared/useResolveHandler';

import { initializeAccountValues, newAccountWizardSteps } from '../../utility';
import WizardModal from '../WizardModal/WizardModal';

const AddNewAccountModal = ({ isOpen, onClose, id, country }) => {
  const queryClient = useQueryClient();
  const { isLoading, mutate } = useMutationAddNewAccount();
  const initialValues = initializeAccountValues(country);
  const { responseStatus, setStatus } = useResolveHandler();

  const onSubmit = (submitData, formikHelpers) => {
    const data = {
      subdomain: submitData.subdomain,
      accountType: submitData.accountType,
      subscription: submitData.accountType === 'LIVE_INSTANCE' ? buildSubscriptionPayload(submitData) : {},
    };

    mutate(
      { id, data },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries(['customersAccounts', id]);
          formikHelpers.resetForm();
          setStatus(true, onClose);
        },
      }
    );
  };

  return (
    <WizardModal
      onClose={onClose}
      isOpen={isOpen}
      initialValues={initialValues}
      onSubmit={onSubmit}
      title='New Account'
      isLoading={isLoading}
      generateWizardStepsWithValidation={newAccountWizardSteps}
      responseStatus={responseStatus}
      submitButtonText='Add'
      updateKey='accountType'
    />
  );
};

export default AddNewAccountModal;
